import IenApi from '../api/IenApi'
import { errorIenProcesThrow } from '../utils/errorIenProces'
import { useFetchCatche } from './useFetchCatche'

export const ERR_IEN_401 = 'ERR_IEN_401'
export const useContractSubmsInfoExtSys = (extSystemId: string, extObjectId: string) => {
  return useFetchCatche(
    () => IenApi.getContractSubmsInfoExtSys(extSystemId, extObjectId).catch(e => {
      if (e?.response?.status === 401) {
        throw ERR_IEN_401
      }
      errorIenProcesThrow(e)
    }), `info${extSystemId}${extObjectId}`
  )
}
